// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0WQ0S {
  overflow: hidden;
  display: flex;
  align-items: center; }
  .styles_container__0WQ0S img {
    border-radius: 50%;
    height: 3.6rem;
    width: 3.6rem; }
  .styles_container__0WQ0S .styles_profileIconContainer__XF-\\+c {
    border-radius: 50%;
    height: 5.4rem;
    width: 5.4rem;
    max-height: 100%;
    max-width: 100%;
    border: 1px solid #3C3B3B80;
    display: flex;
    align-items: center;
    justify-content: center; }
    .styles_container__0WQ0S .styles_profileIconContainer__XF-\\+c .styles_profileIcon__wBFyO {
      height: 72%;
      width: 72%; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/IdentityCard/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAgB;EAChB,aAAa;EACb,mBAAmB,EAAA;EAHvB;IAKM,kBAAkB;IAClB,cAAc;IACd,aAAa,EAAA;EAPnB;IAUM,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;IAlB7B;MAoBQ,WAAW;MACX,UAAU,EAAA","sourcesContent":[".container {\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    img {\n      border-radius: 50%;\n      height: 3.6rem;\n      width: 3.6rem;\n    }\n    .profileIconContainer {\n      border-radius: 50%;\n      height: 5.4rem;\n      width: 5.4rem;\n      max-height: 100%;\n      max-width: 100%;\n      border: 1px solid #3C3B3B80;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      & .profileIcon {\n        height: 72%;\n        width: 72%;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0WQ0S`,
	"profileIconContainer": `styles_profileIconContainer__XF-+c`,
	"profileIcon": `styles_profileIcon__wBFyO`
};
export default ___CSS_LOADER_EXPORT___;
